export const textRegex = new RegExp(/^[^#@$%*?"<>|:\\/]+$/);
